"use client";
import React from "react";
import { Link } from "react-router-dom";
import Footer from "../components/Footer";

export default function GDPRPolicy() {
  return (
    <>
      {/* Page container */}
      <div
        className="w-full py-16 px-6 md:px-12"
        style={{
          backgroundColor: "var(--nhs-pale-grey)",
          color: "var(--nhs-black)",
        }}
      >
        <div className="max-w-4xl mx-auto">
          <Link
            to="/"
            className="inline-flex items-center mb-8 px-4 py-3 font-bold no-underline"
            style={{
              color: "var(--nhs-dark-blue)",
              backgroundColor: "var(--nhs-white)",
              border: "2px solid var(--nhs-dark-blue)",
              boxShadow: "0 3px 0 var(--nhs-dark-blue)",
            }}
          >
            <span aria-hidden="true" className="mr-2">
              ←
            </span>
            Back to home
          </Link>
          {/* Page title */}
          <h1
            className="text-4xl font-bold mb-2"
            style={{ color: "var(--nhs-dark-blue)" }}
          >
            GDPR & Data Protection Policy
          </h1>

          <p className="text-sm mb-6" style={{ color: "var(--nhs-dark-grey)" }}>
            Last updated: 13 December 2025
          </p>

          <p className="text-lg mb-8">
            Prince George University Hospital (PGUH) is committed to protecting
            the privacy and personal data of our members, in line with the UK
            General Data Protection Regulation (UK GDPR) and the Data Protection
            Act 2018.
          </p>

          {/* Section: Data we collect */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">What data we collect</h2>
            <p className="mb-4">
              PGUH may collect the following personal data:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Email addresses</li>
            </ul>
            <p className="mt-4">
              We do not collect unnecessary or excessive personal information.
            </p>
          </section>

          {/* Section: How data is used */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">How we use your data</h2>
            <p className="mb-4">
              Your personal data is used solely for legitimate PGUH purposes,
              including:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Contacting you regarding PGUH-related matters</li>
              <li>Managing staff applications, roles, and communications</li>
              <li>Account verification where required</li>
            </ul>
            <p className="mt-4">
              Your data will never be sold or used for marketing or unrelated
              purposes.
            </p>
          </section>

          {/* Section: Storage */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">How your data is stored</h2>
            <p>
              Personal data is stored securely using appropriate technical and
              organisational measures. Access is restricted to authorised senior
              staff only. We take reasonable steps to protect data from
              unauthorised access, loss, alteration, or disclosure.
            </p>
          </section>

          {/* Section: Retention */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">
              How long we keep your data
            </h2>
            <p>
              Personal data is retained only for as long as it is necessary for
              the purpose it was collected. If you leave PGUH or your data is no
              longer required, it will be securely deleted.
            </p>
          </section>

          {/* Section: Rights */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">Your rights</h2>
            <p className="mb-4">Under UK GDPR, you have the right to:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Request access to your personal data</li>
              <li>Request correction of inaccurate data</li>
              <li>Request deletion of your data where applicable</li>
              <li>Object to or restrict processing in certain circumstances</li>
            </ul>
            <p className="mt-4">
              Requests can be made by contacting PGUH management.
            </p>
          </section>

          {/* Section: Contact */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">Data controller</h2>
            <p className="mb-4">
              Prince George University Hospital (PGUH) acts as the data
              controller for personal data processed in relation to staff
              applications and communications.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">Contact</h2>
            <p>
              If you have any questions about this policy, wish to exercise your
              data protection rights, or need further information, please
              contact PGUH senior management or email us directly at{" "}
              <a
                href="mailto:pguh.co.uk@gmail.com"
                className="font-semibold underline"
                style={{ color: "var(--nhs-dark-blue)" }}
              >
                pguh.co.uk@gmail.com
              </a>
              .
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4">Complaints</h2>
            <p>
              If you are not satisfied with how we handle your personal data,
              you have the right to lodge a complaint with the Information
              Commissioner’s Office (ICO), the UK supervisory authority for data
              protection.
            </p>
          </section>
        </div>
      </div>

      {/* Full NHS Footer */}
      <Footer />
    </>
  );
}
